import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'mh-core-lib-generic-box',
    templateUrl: './core-lib-generic-box.component.html',
    styleUrls: ['./core-lib-generic-box.component.scss'],
    standalone: false
})
export class CoreLibGenericBoxComponent implements OnInit {

  @Input()
  customClass = null;

  constructor() { }

  ngOnInit(): void {
  }

}
